module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_02@2x-3763d34392b71c09b5ef80a43468519a.webp";